export const ONE_MINUTE = 60;
export const ONE_HOUR = 3600;
export const ONE_DAY = 3600 * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_MONTH = ONE_DAY * 31;
export const ONE_YEAR = ONE_DAY * 365;
